export default "__VITE_ASSET__CbL3BQVS__"